import logger from '@getgo/logger';
import loggerTargetLoggingServicePlugin from '@getgo/logger-target-logging-service';
import { v4 as uuidv4 } from 'uuid';
import { getBrowser, getUA, getCpu, getDevice, getEngine, getOS } from './userAgentInfo';

const loggerTargetLoggingService = loggerTargetLoggingServicePlugin({
  server: `${process.env.REACT_APP_LOGGING_SERVICE_BASE_URL}`,
  context: {
    ls_source: 'events-registration-spa',
    ls_sourcetype: 'logging',
  },
});

const appLogger = logger.createRoot(loggerTargetLoggingService);

appLogger.setContext('uuid', uuidv4());
appLogger.setContext('browserInfo', getBrowser());
appLogger.setContext('userAgent', getUA());
appLogger.setContext('cpuInfo', getCpu());
appLogger.setContext('deviceInfo', getDevice());
appLogger.setContext('engineInfo', getEngine());
appLogger.setContext('osInfo', getOS());
appLogger.setContext('module', 'Events RegistrationSPA Service Layer');

try {
  let machineId = window.localStorage.getItem('machineId');
  if (!machineId) {
    machineId = uuidv4();
    window.localStorage.setItem('machineId', machineId);
  }
  appLogger.setContext('machineId', machineId);
} catch (e) {
  console.log('error', e);
}

export default appLogger;
